import axios, { AxiosError } from 'axios';

import {
  axiosInstanceForTenantAPI,
  axiosInstanceWithSlug,
} from '../assets/utils/axiosInstance';
import { FILE_FINISH, FILE_START } from '../constants/reportConstants';
import { ReportFile } from '../interfaces/Report';

interface UploadFileStartPayload {
  fileName: string;
  fileType: string; // can be changed to be specific type accepted by API endpoint
  fileSize: number;
  targetFolder?: number;
}

interface UploadFileToS3BUcketPayload {
  url: string;
  data: FormData;
}

interface UploadFileFinishPayload {
  fileId: number;
}

const reportFileService = {
  getFile: async ({ url, fileName }: ReportFile) => {
    const response = await axios.get(url, { responseType: 'blob' });

    return new File([response.data], fileName);
  },
  uploadFileStart: async (payload: UploadFileStartPayload) => {
    try {
      const { fileName, fileSize, fileType } = payload;
      const body = {
        file_name: fileName,
        file_type: fileType,
        file_size: fileSize,
      };
      const response = await axiosInstanceWithSlug().post(FILE_START, body);

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  customerUploadFileStart: async (payload: UploadFileStartPayload) => {
    try {
      const { fileName, fileSize, fileType, targetFolder } = payload;
      const body = {
        file_name: fileName,
        file_type: fileType,
        file_size: fileSize,
        ...(targetFolder ? { folder: targetFolder } : {}),
      };
      const response = await axiosInstanceForTenantAPI().post(FILE_START, body);

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  uploadFileToS3Bucket: async (payload: UploadFileToS3BUcketPayload) => {
    try {
      const { url, data } = payload;
      const response = await axios({
        url,
        data,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  uploadFileFinish: async (payload: UploadFileFinishPayload) => {
    try {
      const { fileId } = payload;
      const body = { file_id: fileId };
      const response = await axiosInstanceWithSlug().post(FILE_FINISH, body);

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  customerUploadFileFinish: async (payload: UploadFileFinishPayload) => {
    try {
      const { fileId } = payload;
      const body = { file_id: fileId };
      const response = await axiosInstanceForTenantAPI().post(
        FILE_FINISH,
        body,
      );

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
};

export default reportFileService;
